import React from 'react';

const AvailablePacks = () => {
  const packs = [
    {
      id: 1,
      title: "Pack Découverte",
      subtitle: "Individuel ou Groupe",
      description: "1 atelier ou module thématique",
      features: [
        "Accès limité aux ressources en ligne",
        "Support technique de base",
        "Découverte des outils principaux"
      ],
      recommendation: "Idéal pour tester",
      color: "green",
      icon: "🟢",
      price: "À partir de 49€",
      popular: false
    },
    {
      id: 2,
      title: "Pack Standard",
      subtitle: "Individuel ou Groupe",
      description: "Programme trimestriel",
      features: [
        "Accès complet à la plateforme",
        "Suivi des progrès des élèves",
        "Kits inclus (partagés pour groupe)",
        "Support prioritaire",
        "Ressources pédagogiques complètes"
      ],
      recommendation: "Parfait pour un cycle d'apprentissage",
      color: "blue",
      icon: "🔵",
      price: "À partir de 149€",
      popular: true
    },
    {
      id: 3,
      title: "Pack Premium",
      subtitle: "Individuel ou Groupe",
      description: "Programme annuel complet",
      features: [
        "Ateliers réguliers + accompagnement tuteurs",
        "Kits individuels (un par élève)",
        "Formation des enseignants incluse",
        "Certificats officiels NextMaker",
        "Support premium 7j/7",
        "Accès à tous les modules avancés",
        "Reporting détaillé des progrès"
      ],
      recommendation: "Solution complète pour l'année scolaire",
      color: "purple",
      icon: "🟣",
      price: "À partir de 399€",
      popular: false
    }
  ];

  const getColorClasses = (color) => {
    switch (color) {
      case 'green':
        return {
          bg: 'bg-green-1',
          text: 'text-dark-2',
          border: 'border-green-1',
          light: 'bg-green-1 bg-opacity-20'
        };
      case 'blue':
        return {
          bg: 'bg-blue-1',
          text: 'text-white',
          border: 'border-blue-1',
          light: 'bg-blue-1 bg-opacity-20'
        };
      case 'purple':
        return {
          bg: 'bg-purple-1',
          text: 'text-white',
          border: 'border-purple-1',
          light: 'bg-purple-1 bg-opacity-20'
        };
      default:
        return {
          bg: 'bg-gray-500',
          text: 'text-white',
          border: 'border-gray-500',
          light: 'bg-gray-200'
        };
    }
  };

  return (
    <section className="py-16 px-4 md:px-8 lg:px-16 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-dark-1 mb-4 font-sans">
            Exemple de packs disponibles
          </h2>
          <p className="text-light-1 text-lg max-w-3xl mx-auto font-sans">
            Des solutions adaptées à tous les besoins et budgets
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {packs.map((pack) => {
            const colorClasses = getColorClasses(pack.color);
            
            return (
              <div 
                key={pack.id} 
                className={`relative rounded-2xl p-8 shadow-sm border transition-all duration-300 ${
                  pack.popular 
                    ? 'border-2 border-blue-1' 
                    : 'border-light-3'
                } bg-white`}
              >
                {pack.popular && (
                  <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                    <span className="bg-blue-1 text-white text-sm font-medium px-4 py-1 rounded-full">
                      Le plus populaire
                    </span>
                  </div>
                )}
                
                <div className="text-center mb-6">
                  <div className="text-3xl mb-2">{pack.icon}</div>
                  <h3 className={`text-xl font-bold font-sans ${colorClasses.text} mb-1`}>
                    {pack.title}
                  </h3>
                  <p className="text-light-1 text-sm font-sans mb-3">
                    {pack.subtitle}
                  </p>
                </div>

                <div className="mb-6">
                  <p className="font-semibold text-dark-1 text-center font-sans mb-4">
                    {pack.description}
                  </p>
                  <ul className="space-y-3">
                    {pack.features.map((feature, index) => (
                      <li key={index} className="flex items-start">
                        <svg className="w-5 h-5 text-green-1 mr-3 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                        <span className="text-dark-1 text-sm font-sans">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className={`rounded-lg p-4 mb-6 ${colorClasses.light}`}>
                  <p className={`text-center font-medium font-sans text-sm ${colorClasses.text}`}>
                    {pack.recommendation}
                  </p>
                </div>
                
                <button className={`w-full bg-red-4 hover:bg-white text-white hover:text-red-4 font-sans py-3 px-6
            rounded-full transition-colors duration-300 border-2 border-red-4 ${
                  pack.popular ? 'shadow-lg' : ''
                }`}>
                  {pack.popular ? 'Choisir ce pack' : 'En savoir plus'}
                </button>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <p className="text-light-1 mb-6 font-sans">
            Vous avez des besoins spécifiques ? Nous créons des solutions sur mesure.
          </p>
          <a href="/contact">
            <button className="border border-purple-1 text-purple-1 hover:bg-purple-1 hover:text-white font-sans font-medium py-3 px-8 rounded-full transition-colors duration-300">
              Contacter un conseiller
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default AvailablePacks;